import axios from 'axios';
import * as config from '../config';

export const SETISLOADINGINUSERS = 'users/SETISLOADINGINUSERS';
export const SETUSERS = 'users/SETUSERS';

export const getUsers = (onSuccess = () => {}, onError = () => {}) => {
  return (dispatch) => {
    dispatch({ type: SETISLOADINGINUSERS, isLoadingUsers: true });

    // Fetch KC users and DB network map in parallel, then merge
    Promise.all([
      axios(`${config.endpoints.base_url}v1/godlike/users`),
      axios(`${config.endpoints.base_url}v1/godlike/users/networks`),
    ])
      .then(([usersResp, networksResp]) => {
        const kcUsers = Array.isArray(usersResp.data.data) ? usersResp.data.data : [];
        const networksMap = networksResp.data.data ?? {};
        const merged = kcUsers.map((u) => ({
          ...u,
          dbNetworks: networksMap[u.id] || [],
        }));
        dispatch({ type: SETISLOADINGINUSERS, isLoadingUsers: false });
        dispatch({ type: SETUSERS, users: merged });
        return onSuccess({ data: merged });
      })
      .catch((err) => {
        dispatch({ type: SETISLOADINGINUSERS, isLoadingUsers: false });
        onError(err);
      });
  };
};

export const updateUserNetworks = (authUserId, networks) => {
  return axios.put(
    `${config.endpoints.base_url}v1/godlike/users/${authUserId}/networks`,
    { networks }
  );
};

// Fetches all networks from the GodLike endpoint — no user-network filter, sorted by name
export const fetchAllNetworks = () => {
  return axios(`${config.endpoints.base_url}v1/godlike/networks`)
    .then((resp) => resp.data.data ?? []);
};

